import { render, staticRenderFns } from "./BaseSort.vue?vue&type=template&id=002457e8&scoped=true&"
import script from "./BaseSort.vue?vue&type=script&lang=js&"
export * from "./BaseSort.vue?vue&type=script&lang=js&"
import style0 from "./BaseSort.vue?vue&type=style&index=0&id=002457e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002457e8",
  null
  
)

export default component.exports